import { t } from 'i18next';
// components
import { RsuiteTooltip } from '@commons/components';
import { Avatar, AvatarGroup, Popover, Whisper } from 'rsuite';
// utils && hooks
import stringAvatar from 'utils/avatar-name';
// styles
import styles from './PdvAvatars.module.css';

const PdvAvatars = ({ data, isAll }) => {
    return (
        <div className={styles['avatars']}>
            {isAll ? (
                <p className={styles['text-light']}>{t('listAgreements.placeholder.pos.all')}</p>
            ) : data?.length > 0 ? (
                <AvatarGroup stack style={{ alignItems: 'center' }}>
                    {data
                        ?.filter((drugManufacturer, i) => i < 4)
                        .map(({ name }, i) => (
                            <RsuiteTooltip placement="bottom" trigger="hover" text={name} key={name}>
                                <Avatar size="md" className={styles['avatar']} circle key={name} alt={name}>
                                    {stringAvatar(name, false, 0)}
                                </Avatar>
                            </RsuiteTooltip>
                        ))}
                    {data?.length > 4 && (
                        <Whisper
                            placement="bottom"
                            speaker={
                                <Popover>
                                    {data
                                        .filter((drugManufacturer, i) => i >= 4)
                                        .map(({ name }, index) => {
                                            return (
                                                <>
                                                    <div className={styles['container-n-avatars']}>
                                                        <Avatar circle className={styles['avatar']} size="md">
                                                            {stringAvatar(name, false, 0)}
                                                        </Avatar>
                                                        <p className={styles['text-avatar-n-droguerias']}>{name}</p>
                                                    </div>
                                                    <hr className={styles['line-divider']} />
                                                </>
                                            );
                                        })}
                                </Popover>
                            }
                        >
                            <Avatar circle size="md" className={styles['avatars-menu']}>
                                {`+ ${data.slice(4).length} PDV`}
                            </Avatar>
                        </Whisper>
                    )}
                </AvatarGroup>
            ) : (
                '-'
            )}
        </div>
    );
};

export default PdvAvatars;
